import inject from './inject'
import props from './props'
import methods from './methods'
import render from './render'

export default {
  inject,
  props,
  methods,
  render,
  mounted () {
    if (this.autoclick) {
      if (!localStorage.getItem('cypress')) {
        this.onClick()
      }
    }
  }
}
